import React from 'react';
import RevisionItem from '../containers/RevisionItemContainer';

const List = ({ revisions }) => (
  <div>{revisions.map(revision => <RevisionItem key={`${revision.id}`} revision={revision} />)}</div>
);

export default List;
